import ArrowUp from './src/arrow-up-combined';
export default ArrowUp;